import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import { useHistory, useParams } from 'react-router-dom';
import Icon from '../../../components/Icon';
import Title from '../../../components/Title';
import { useGetPublisherQuery } from '../../../api/publisherApiSlice';
import { DateRangeFilterButton } from '../../../components/DateRangeFilterButton';
import { PublisherDashboardContainer } from '../../../components/publisher/PublisherDashboardContainer';
import FilterButton, {FilterGroup} from "../../../components/FilterButton";

const Publisher = ({value}) => {
  const publisherId = useParams()["publisherId"];
  const history = useHistory();
	const { t } = useTranslation();
  const { data: publisher, isSuccess } = useGetPublisherQuery({publisherId})
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  if(!isSuccess ) { return (<></>) }

  return (
    <>
      <Title main={publisher.name} sub={t("menu.devices")} group={true} onBack={()=>(history.push('/publishers'))}>
        <Button onClick={()=>( history.push(`/publishers/${publisherId}/credentials`))}>
          <Icon icon='key' text={t("publisher.actions.credentials")} />
        </Button>
        <Button onClick={()=>( history.push(`/publishers/${publisherId}/cmp/configuration`)) }>
          <Icon icon='check-square' text={t("publisher.actions.cmp_configuration")} />
        </Button>
        <Button onClick={()=>( history.push(`/publishers/${publisherId}/cmp/analytics`)) }>
          <Icon icon='chart' text={t("publisher.actions.cmp_analytics")} />
        </Button>
        <Button onClick={()=>( history.push(`/publishers/${publisherId}/sdk/configs`)) }>
          <Icon icon='configure' text={t("publisher.actions.sdk_configuration")} />
        </Button>
        <Button onClick={()=>( history.push(`/publishers/${publisherId}/sdk/remote_configuration`)) } >
          <Icon icon='branch' text={t("publisher.actions.remote_params")} />
        </Button>
        <Button onClick={()=>( history.push(`/publishers/${publisherId}/revenues`))}>
          <Icon icon='revenue' text={t("publisher.actions.revenues")} />
        </Button>
        <Button onClick={()=>( history.push(`/publishers/${publisherId}/users`))}>
          <Icon icon='users-solid' text={t("publisher.actions.users")} />
        </Button>
        <Button onClick={()=>( history.push(`/publishers/${publisherId}/admin`)) }>
          <Icon icon='admin' text={t("publisher.actions.admin")} />
        </Button>
      </Title>
      <FilterGroup onChange={({startDate, endDate}) => {
        setStartDate(startDate)
        setEndDate(endDate)
      }}>
        <DateRangeFilterButton
          startDate={publisher.start_date}
          endDate={publisher.end_date}
        />
      </FilterGroup>
      <PublisherDashboardContainer publisherId={publisherId} startDate={startDate} endDate={endDate} />
    </>
  )
}

export default Publisher
